import { jsx as p } from "react/jsx-runtime";
import { createContext as m, useState as e, useMemo as x, useContext as C } from "react";
const i = m(void 0), w = ({
  defaultSideNav: t,
  defaultSideUser: n,
  defaultTopNav: a,
  children: c
}) => {
  const [o, l] = e(t), [s, L] = e(n), [r, f] = e(a), [u, d] = e({
    isTop: !0,
    isBottom: !0,
    isLeft: !0,
    isRight: !0
  }), v = x(
    () => ({
      collapsed: u,
      setCollapsed: d,
      sideNav: o,
      sideUser: s,
      topNav: r
    }),
    [u, o, s, r]
  );
  return /* @__PURE__ */ p(i.Provider, { value: v, children: c });
}, y = () => {
  const t = C(i);
  if (t === void 0)
    throw new Error("useCount must be used within a CountProvider");
  return t;
};
export {
  w as L,
  y as u
};
